import refs from '../helpers/refs'
import device from '../helpers/device'

class CFeature3Up {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    if (device.isDesktop()) {
      if (this.$refs.feature2) {
        this.$refs.feature2.addEventListener('mouseenter', () => {
          this.$refs.feature1Content.classList.add('md:opacity-0')
        })

        this.$refs.feature2.addEventListener('mouseleave', () => {
          this.$refs.feature1Content.classList.remove('md:opacity-0')
        })
      } else {
        console.warn('[c-feature-3up] Feature 2 element with ref="feature2" was not found.')
      }

      if (this.$refs.feature3) {
        this.$refs.feature3.addEventListener('mouseenter', () => {
          this.$refs.feature1Content.classList.add('md:opacity-0')
        })

        this.$refs.feature3.addEventListener('mouseleave', () => {
          this.$refs.feature1Content.classList.remove('md:opacity-0')
        })
      } else {
        console.warn('[c-feature-3up] Feature 3 element with ref="feature3" was not found.')
      }
    }
  }
}

// DEBUG - Feature 3up is breaking other components, still not sure why
// TODO: Remove onload or convert to onDOM if not necessary
window.addEventListener('load', () => {
  document
    .querySelectorAll('.c-feature-3up')
    .forEach(el => new CFeature3Up(el))
})
